<nav class="sir-container" aria-label="Pagination">
    @if (currentPage > 1) {
        <button
            type="button"
            siriusButton
            [iconName]="'arrow_left'"
            [buttonType]="'primary'"
            [buttonText]="'button.previous' | translate"
            [iconPos]="'left'"
            (click)="decrementPageNumber()"></button>
    }
    <div class="sir-paging">
        <div class="sir-page-index-container">
            <button
                #pageIndexTrigger
                [id]="pagingTriggerId"
                type="button"
                class="sir-page-index"
                (click)="setDropdownOpen(!isOpen)"
                (keydown)="onTriggerKeydown($event)"
                [attr.aria-expanded]="isOpen"
                [attr.aria-controls]="pagingOptionsId"
                aria-haspopup="listbox"
                [ngClass]="{ 'sir-page-index-open': isOpen }">
                <div class="sir-text">
                    <span class="sir-page-index-text sir-text-style-button-m-default"
                        >{{ 'page.page' | translate }} {{ currentPage }} {{ 'page.of' | translate }}
                        {{ options.length }}</span
                    >
                    <span class="sir-page-index-text-ghost" aria-hidden="true"
                        >{{ 'page.page' | translate }} {{ options.length }} {{ 'page.of' | translate }}
                        {{ options.length }}</span
                    >
                </div>
                @if (isOpen) {
                    <sirius-icon aria-hidden="true" name="caret_up"></sirius-icon>
                } @else {
                    <sirius-icon aria-hidden="true" name="caret_down"></sirius-icon>
                }
            </button>
            <div class="sir-paging-options-container">
                @if (isOpen) {
                    <div
                        [id]="pagingOptionsId"
                        class="sir-paging-options"
                        [ngClass]="{ 'sir-paging-options-open': isOpen }"
                        tabindex="-1"
                        role="listbox"
                        [attr.aria-labelledby]="pagingTriggerId">
                        @for (opt of options; track opt; let index = $index) {
                            <button
                                #pageOption
                                type="button"
                                class="sir-option sir-text-style-paragraph-s-default"
                                role="option"
                                [attr.tabindex]="index === activeOptionIndex ? 0 : -1"
                                (keydown)="onOptionKeydown($event, index)"
                                (click)="onSelect(opt); $event.stopPropagation()"
                                [attr.aria-selected]="opt === currentPage"
                                [ngClass]="{
                                    'sir-option-selected': opt === currentPage,
                                }">
                                {{ 'page.page' | translate }} {{ opt }} {{ 'page.of' | translate }}
                                {{ options.length }}
                            </button>
                        }
                    </div>
                }
            </div>
        </div>
    </div>
    @if (currentPage < numberOfPages) {
        <button
            type="button"
            siriusButton
            [iconName]="'arrow_right'"
            [buttonType]="'primary'"
            [buttonText]="'button.next' | translate"
            [iconPos]="'right'"
            (click)="incrementPageNumber()"></button>
    }
</nav>
